const TOKEN_UPDATED = 'finance:token-updated';
const LOGGED_OUT = 'finance:logged-out';

export function emitTokenUpdated(detail) {
  window.dispatchEvent(new CustomEvent(TOKEN_UPDATED, { detail }));
}

export function emitLoggedOut() {
  window.dispatchEvent(new Event(LOGGED_OUT));
}

export function onTokenUpdated(handler) {
  const wrap = (e) => handler(e.detail);
  window.addEventListener(TOKEN_UPDATED, wrap);
  return () => window.removeEventListener(TOKEN_UPDATED, wrap);
}

export function onLoggedOut(handler) {
  window.addEventListener(LOGGED_OUT, handler);
  return () => window.removeEventListener(LOGGED_OUT, handler);
}
